import { render, staticRenderFns } from "./_commissionStatements.vue?vue&type=template&id=96c2adb0&scoped=true&"
import script from "./_commissionStatements.vue?vue&type=script&lang=js&"
export * from "./_commissionStatements.vue?vue&type=script&lang=js&"
import style0 from "./_commissionStatements.vue?vue&type=style&index=0&id=96c2adb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c2adb0",
  null
  
)

export default component.exports